<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent>
        <v-card class="mt-3 pa-1">
            <Title title="初期設定" />
            <v-card-title class="pa-0">
                <v-container fluid>
                    <v-row dense justify="center">
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-card class="pa-1" :color="target=='name' ? 'cyan lighten-4' : ''">
                                <template v-if="target=='name'">
                                    <v-card class="pa-2">
                                        <v-sheet rounded :class="'pa-2 mb-1 '+($vuetify.breakpoint.xs ? 'caption' : 'body-1')">
                                            あなたのお名前を入力して下さい。
                                        </v-sheet>
                                        <v-text-field 
                                            v-model="editItems.userName" 
                                            clearable 
                                            label="名前" 
                                            outlined
                                            dense
                                            type="text"
                                            :rules="[validatorRequire]" />
                                        <v-card-actions>
                                            <v-scale-transition>
                                                <v-btn v-if="editItems.userName != null && editItems.userName.trim().length > 0" color="primary" @click="onClickNext('place')"><v-icon>mdi-arrow-down</v-icon>次</v-btn>
                                            </v-scale-transition>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                                <template v-else>
                                    <v-card-text class="pa-1">
                                        あなたのお名前<br/>
                                        <strong>{{editItems.userName}}</strong>
                                    </v-card-text>
                                </template>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center">
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-card class="pa-1" :color="target=='place' ? 'cyan lighten-4' : ''">
                                <template v-if="target=='place'">
                                    <v-card class="pa-2">
                                        <v-sheet rounded :class="'pa-2 mb-1 '+($vuetify.breakpoint.xs ? 'caption' : 'body-1')">
                                            あなたの圃場の名前を入力して下さい。<br/>
                                            複数の圃場を所持されている時は、まずはその中から一つを入力します。<br/>
                                            圃場がない時は、"圃場なし" をチェックして下さい。
                                        </v-sheet>
                                        <v-checkbox
                                            v-model="editItems.isPlaceNone"
                                            label="圃場なし"
                                            dense
                                            hide-details
                                            class="mb-3" />
                                        <v-text-field 
                                            v-model="editItems.placeName" 
                                            clearable 
                                            label="圃場の名前" 
                                            dense
                                            outlined 
                                            type="text" 
                                            :rules="editItems.isPlaceNone ? [] : [validatorRequire]" />
                                        <v-card-actions>
                                            <v-btn color="primary" @click="onClickPrevious('name')"><v-icon>mdi-arrow-up</v-icon>前</v-btn>
                                            <v-scale-transition>
                                                <v-btn v-if="!editItems.isPlaceNone && editItems.placeName != null && editItems.placeName.trim().length > 0" color="primary" @click="onClickNext('crop')"><v-icon>mdi-arrow-down</v-icon>次</v-btn>
                                                <v-btn v-if="editItems.isPlaceNone" color="primary" @click="onClickComplete">終わり</v-btn>
                                            </v-scale-transition>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                                <template v-else>
                                    <v-card-text v-if="!editItems.isPlaceNone" class="pa-1">
                                        圃場の名前<br/>
                                        <strong>{{editItems.placeName}}</strong>
                                    </v-card-text>
                                    <v-card-text v-else class="pa-1">
                                        <strong>圃場無し</strong>
                                    </v-card-text>
                                </template>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-if="!editItems.isPlaceNone" dense justify="center">
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-card class="pa-1" :color="target=='crop' ? 'cyan lighten-4' : ''">
                                <template v-if="target=='crop'">
                                    <v-card class="pa-2">
                                        <v-sheet rounded :class="'pa-2 mb-1 '+($vuetify.breakpoint.xs ? 'caption' : 'body-1')">
                                            入力した圃場で作付けしている作物の品目を入力して下さい。<br/>
                                            例えば、"アスパラガス" の "アスペルジュ・ソバージュ" を作付けされている時は<br/>
                                            "アスパラガス" と入力します。
                                        </v-sheet>
                                        <v-text-field 
                                            v-model="editItems.cropName" 
                                            clearable 
                                            dense
                                            label="品目" 
                                            outlined 
                                            type="text" 
                                            :rules="[validatorRequire]" />
                                        <v-divider />
                                        <v-card-actions>
                                            <v-btn color="primary" @click="onClickPrevious('place')"><v-icon>mdi-arrow-up</v-icon>前</v-btn>
                                            <v-scroll-x-transition>
                                                <v-btn v-if="editItems.cropName != null && editItems.cropName.trim().length > 0" color="primary" @click="onClickNext('variety')"><v-icon>mdi-arrow-down</v-icon>次</v-btn>
                                            </v-scroll-x-transition>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                                <template v-else>
                                    <v-card-text class="pa-1">
                                        品目<br/>
                                        <strong>{{editItems.cropName}}</strong>
                                    </v-card-text>
                                </template>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row v-if="!editItems.isPlaceNone" dense justify="center">
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-card class="pa-1" :color="target=='variety' ? 'cyan lighten-4' : ''">
                                <template v-if="target=='variety'">
                                    <v-card class="pa-2">
                                        <v-sheet rounded :class="'pa-2 mb-1 '+($vuetify.breakpoint.xs ? 'caption' : 'body-1')">
                                            入力した品目の品種を一つ入力して下さい。<br/>
                                            例えば、"アスペルジュ・ソバージュ" や "あまおう" 等です。
                                        </v-sheet>
                                        <v-text-field 
                                            v-model="editItems.varietyName" 
                                            clearable 
                                            dense
                                            label="品種" 
                                            outlined 
                                            type="text" 
                                            :rules="[validatorRequire]" />
                                        <v-divider />
                                        <v-card-actions>
                                            <v-btn color="primary" @click="onClickPrevious('crop')"><v-icon>mdi-arrow-up</v-icon>前</v-btn>
                                            <v-scroll-x-transition>
                                                <v-btn v-if="editItems.varietyName != null && editItems.varietyName.trim().length > 0" color="primary" @click="onClickComplete">終わり</v-btn>
                                            </v-scroll-x-transition>
                                        </v-card-actions>
                                    </v-card>
                                </template>
                                <template v-else>
                                    <v-card-text class="pa-1">
                                        品種<br/>
                                        <strong>{{editItems.varietyName}}</strong>
                                    </v-card-text>
                                </template>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-expand-transition>
                        <v-row dense v-if="target=='confirm'" justify="center">
                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <v-card class="pa-1" color="cyan lighten-4">
                                    <v-card class="pa-2">
                                        <v-sheet rounded :class="'pa-2 mb-1 '+($vuetify.breakpoint.xs ? 'caption' : 'body-1')">
                                            この内容で初期設定を終了します。<br/>宜しいですか？
                                        </v-sheet>
                                        <v-card-actions>
                                            <v-btn color="primary" @click="onClickPrevious(editItems.isPlaceNone ? 'place' : 'variety')"><v-icon>mdi-arrow-up</v-icon>前</v-btn>
                                            <v-scroll-x-transition>
                                                <v-btn color="primary" @click="onClickSave"><v-icon>mdi-content-save-outline</v-icon>初期設定を終了</v-btn>
                                            </v-scroll-x-transition>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-expand-transition>
                </v-container>
            </v-card-title>
        </v-card>
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    
    export default {
        components: {
            Title,
            TitleButton,
            Confirm
        },
        data: function () {
            return {
                isView: false,
                userUID: "",
                target: "name",
                editItems: {
                    userName: "",
                    isPlaceNone: false,
                    placeName: "",
                    cropName: "",
                    varietyName: ""
                },
                validatorRequire: value => !!value || '必須入力です。',
            }
        },
        methods: {
            /**
             * 前ボタン押下時
             */
            onClickPrevious: function (target) {
                this.target = target
            },
            /**
             * 次ボタン押下時
             */
            onClickNext: function (target) {
                this.target = target
            },
            /**
             * 終わりボタン押下時
             */
            onClickComplete: function () {
                this.target = "confirm"
            },
            /**
             * 初期設定終了ボタン押下時
             */
            onClickSave: function () {

                const self = this

                // バッチで各データを登録する
                const batch = db.batch()

                // ユーザーデータ作成
                const userData = {
                    version: "1.0.0",
                    userUID: this.userUID,
                    userID: "",
                    userName: this.editItems.userName,
                    address: {
                        postalCode: "",
                        pref: "",
                        city: "",
                        address1: "",
                        address2: "",
                        areaID: ""
                    },
                    notification: {
                        enabled: false,     
                        email: ""
                    },
                    avaterImage: null,
                    publicSetting: 0,
                    isSystemManager: false,
                    systemNotification: {
                        lastDateTime: ""
                    },
                    referenceUserInfo: {
                        group: {
                            ownerUserUID: null,
                            groupNo: 0
                        },
                        userUID: null
                    },
                    registeredDateTime: this.df_currentDateTime(),
                    updatedDateTime: ""
                }
                console.log("userData", userData)
                batch.set(db.collection("users").doc(this.userUID), userData)

                if (!this.editItems.isPlaceNone) {

                    // 品目データ作成
                    const crop = {
                        version: "1.0.0", 
                        cropID: 1, 
                        name: this.editItems.cropName
                    }
                    console.log("crop", crop)
                    batch.set(db.collection("users").doc(this.userUID).collection("crops").doc(crop.cropID+""), crop)

                    // 品種データ作成
                    const variety = {
                        version: "1.0.0", 
                        cropID: crop.cropID, 
                        varietyID: 1, 
                        name: this.editItems.varietyName
                    }
                    console.log("variety", variety)
                    batch.set(db.collection("users").doc(this.userUID).collection("crops").doc(crop.cropID+"").collection("varieties").doc(variety.varietyID+""), variety)

                    // 場所データ作成
                    const place = {
                        version: "1.0.0",
                        placeID: 1,
                        cultivationType: null,
                        name: this.editItems.placeName,
                        details: {
                            area: 0,
                            variety: {
                                cropID: 1,
                                varietyID: 1
                            }
                        },
                        address: {
                            postalCode: "",
                            pref: "",
                            city: "",
                            address1: "",
                            address2: "",
                            areaID: ""
                        },
                        placeGroupID: "",
                        isDeleted: false,
                        streamingURLs: [],
                        image: null,
                        groupUserAuthorities: ["browse", "work", "environment"],
                        managementAgrichemical: {
                            enabled: false,
                            target: null,
                            dateTime: "",
                            startDate: {
                                month: 1,
                                day: 1
                            },
                        },
                        memo: "",
                        register: {
                            userUID: this.userUID,
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        },
                    }
                    console.log("place", place)
                    batch.set(db.collection("users").doc(this.userUID).collection("places").doc(place.placeID+""), place)
                }

                // コミット
                batch.commit().then(function(){
                    self.$store.commit("userData", userData)
                    self.$emit("onCompletedInitialSetting")
                    self.isView = false
                }).catch(function(error){
                    console.log(error)
                    self.$store.commit("notification", {message:"初期登録に失敗しました。("+error+")", isError:true})
                    self.mi_writeLog("InitialSetting/onClickSave", "exception("+error+")")
                })

            },
            /**
             * このダイアログを表示
             */
            show: function (userUID) {
                this.editItems.userName = this.$store.getters["firebaseUser"].displayName
                this.userUID = userUID
                this.isView = true
            }
        }
    }
</script>
            {key: "browse", text: "参照"},
            {key: "work", text: "作業の参照"},
            {key: "work.record", text: "作業の参照と作業記録"},
            {key: "environment", text: "環境の参照"},
            {key: "environment.record", text: "環境の参照と記録"},
                if (place == null) {
                    var id = 1
                    if (self.places.length >= 1) {
                        id = Math.max(...self.places.map(m => m.body.placeID)) + 1
                    }
                    place = {
                        version: "1.0.0",
                        placeID: id,
                        isDeleted: false,
                        register: {
                            userUID: userUID,
                            dateTime: self.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        },
                    }
                } else {
                    place.updater.userUID = userUID,
                    place.updater.dateTime = self.df_currentDateTime()
                }

                place.name = self.editItems.name
                place.placeGroupID = self.editItems.group
                place.address = {
                    postalCode: self.editItems.address.postalCode,
                    pref:self.editItems.address.pref,
                    city:self.editItems.address.city,
                    address1:self.editItems.address.address1,
                    address2:self.editItems.address.address2,
                    areaID: self.editItems.address.areaID
                }
                
                place.cultivationType = self.editItems.cultivationType
                place.details = {
                    area: self.editItems.details.area * 1,
                    variety: {
                        cropID: self.editItems.details.variety.cropID,
                        varietyID: self.editItems.details.variety.varietyID,
                    }
                }
                place.memo = self.editItems.memo

                place.streamingURLs = []
                if (self.editItems.streamingURLs.length > 1) {
                    self.editItems.streamingURLs.forEach(function(url){
                        if (url.isNewData == false) {
                            place.streamingURLs.push(
                                {
                                    url: url.url,
                                    type: url.type
                                }
                            )
                        }
                    })
                }

                place.groupUserAuthorities = []
                for (var i=0; i<this.editItems.groupUserAuthorities.length; i++) {
                    if (this.editItems.groupUserAuthorities[i].enable) {
                        place.groupUserAuthorities.push(this.editItems.groupUserAuthorities[i].authority.key)
                    }
                }

                if (this.editItems.managementAgrichemical.enabled) {                    
                    var dateTime = place.managementAgrichemical.dateTime == "" ? this.df_currentDateTime() : place.managementAgrichemical.dateTime
                    place.managementAgrichemical = {
                        enabled: this.editItems.managementAgrichemical.enabled,
                        target: this.editItems.managementAgrichemical.target,
                        dateTime: dateTime,
                        startDate: {
                            month: this.editItems.managementAgrichemical.startDate.month,
                            day: this.editItems.managementAgrichemical.startDate.day
                        }
                    }
                } else {
                    place.managementAgrichemical = {
                        enabled: false,
                        target: null,
                        dateTime: "",
                        startDate: {
                            month: 1,
                            day: 1
                        }
                    }
                }